import { z } from 'zod'
import { uuidSchema } from '../validators/uuid.validator.js'
import { irrigationProblemSubjectSchema } from '../enums/irrigation.enum.js'
import { irrigationProblemMaterialDtoSchema } from './irrigation.dto.js'

/**
 * A kind of irrigation problem in the directory, and its usual repair.
 *
 * Configured in Settings like tree problems: the list is the business's. The
 * description reaches a proposal, so it is written for a client.
 */
export const irrigationProblemTypeDtoSchema = z.object({
  id: uuidSchema,
  name: z.string(),
  description: z.string().nullable(),
  appliesTo: z.array(irrigationProblemSubjectSchema),
  defaultLaborMinutes: z.number().int().nonnegative().nullable(),
  defaultMaterials: z.array(irrigationProblemMaterialDtoSchema),
  /**
   * The stock photograph, standing in for one the technician did not take.
   * An id, not a URL: storage is private and every read is a short-lived
   * signed link, as for a tree problem type's.
   */
  photoDocumentId: uuidSchema.nullable(),
  /** A clip explaining what the problem looks like. An id, for the same reason. */
  videoId: uuidSchema.nullable(),
  sortOrder: z.number().int(),
  archivedAt: z.string().datetime().nullable(),
  /** Live problems of this kind, so Settings can say what archiving one affects. */
  problemCount: z.number().int().nonnegative(),
})

export type IrrigationProblemTypeDto = z.infer<
  typeof irrigationProblemTypeDtoSchema
>

export const irrigationProblemTypeListDtoSchema = z.object({
  problemTypes: z.array(irrigationProblemTypeDtoSchema),
})

export type IrrigationProblemTypeListDto = z.infer<
  typeof irrigationProblemTypeListDtoSchema
>
